import { OrganizationKeyName } from "../../../model/Organization";
import { AdminErrorListResponseData } from "../../../service/api-response/AdminFormErrorResponse";

export const UPSERT_HOMEPAGE_FAIL = "SHOP:UPSERT_HOMEPAGE_FAIL";

export const upsertHomepageFailAction = (
  organization: OrganizationKeyName,
  data: any,
  errors: AdminErrorListResponseData,
  id?: string
) => ({
  type: UPSERT_HOMEPAGE_FAIL as typeof UPSERT_HOMEPAGE_FAIL,
  organization,
  data,
  id,
  errors,
});

export type UpsertHomepageFailAction = ReturnType<
  typeof upsertHomepageFailAction
>;
